import React, { Component, lazy, Suspense } from "react";
import { withRouter } from "react-router-dom";

import {
  Page,
  Card,
  Layout,
  SkeletonBodyText,
  Button,
  Pagination,
  Toast,
  SkeletonPage,
  BlockStack,
  // Select,
  Link,
  Modal,
  Spinner,
  InlineStack,
  Box,
  Checkbox,
  Icon,
  Popover,
  // ActionList,
  OptionList,
  Banner
  // Checkbox,Popover,ActionList,ExceptionList,Badge,Modal
} from "@shopify/polaris";
import {
  TickMinor,
  AddMajor,
  ChevronRightMinor,
  ChevronLeftMinor,
  SortMinor
} from '@shopify/polaris-icons';
import utils from "../../../../utils/utils";
import LazyLoad from "react-lazyload";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import AppBridge from "../../../../utils/appBridge";
import _ from "lodash";
import {
  reqGetFindProductsList,
  reqPostAddProductToList,
  reqGetFindProductsMenu,
  reqPreference,
  reqGoogleAnalytics,
  reqGetCoupon,
  reqReceiveCoupon,
  reqFileMapSearch,
  reqGetUserSubcribe,
  getPostCateSelect,
  getGetProductAddSuccess,
} from "../../../../api";

import "../index.css";
import intl from "../../../../i18n/intl";
// import UserProductPreferences from "../../../../components/UserProductPreferences";
import moment from "moment";
import { store } from "../../../../store";
// import { connect} from "react-redux";
import { changeBannerData, changePersonLevel } from "../../../../slice";
const UpgradePlanModal = lazy(() =>
  import("../../SubscriptionPaid/components/UpgradePlanModal")
);
const ImportDsmModal = lazy(() =>
  import("../../SubscriptionPaid/components/ImportDsmModal")
);

class FindProducts extends Component {
  state = {
    //页面动作
    chargeError: false,
    loadingPage: true,
    isSearching: "0",
    page: 1,
    size: 36,
    pageValue: "",
    hasPrevious: false,
    hasNext: true,
    Imageload: false,
    ShowCountNumber: 0,
    total:1,
    // 列表原始数据
    pageData: [],
    // DIV列表数据
    ListDivHtml: <div></div>,
    MenuId: "",
    Child: "",
    tabSelected: 0,
    queryValue: "", // 关键词内容搜索
    sortBy: "",
    PageCount: 0,
    CateValue: "",
    dataList: [],
    cateLists: [],

    togglePopoverActive: false,

    ProductsTitle: "",
    ProductsTitleInfo: "",
    showUserPreferences: false,
    CouponModal: false,
    CouponData: [],
    SeachImage: false,
    //checkChromePlugins: {}, // 接收公共数据中的chorme_plugins id和install_check分别表示谷歌插件ID和安装检查功能是否可用
    CheckGooglePluginActive: false, // 谷歌插件弹窗开关状态
    GooglePluginInstall: false, // 是否安装谷歌插件

    // 斋月节banner ramadan
    ramadanImage: "",
    upgradeModal: false, //升级付费弹窗
    importantLimit: 0, //商品导入限制
    importantDsmModal: false, //dsm产品导入限制
    importantDay: 3, //每天限定导入
    holidayData: {}, //节日商品数据
    holidayBanner: [], //节日轮播图
    isCate: false, // 是否显示选择偏好
    warningMessage:'',
    cateSelectData: [
      {
        label: "Clothing",
        select: 0,
      },
      {
        label: "Beauty & Fitness",
        select: 0,
      },
      {
        label: "Consumer Electronics",
        select: 0,
      },
      {
        label: "Pets & Animals",
        select: 0,
      },
      {
        label: "Toys & Hobbies",
        select: 0,
      },
      {
        label: "Accessories",
        select: 0,
      },
      {
        label: "Home &Garden",
        select: 0,
      },
      {
        label: "People & Society",
        select: 0,
      },
      {
        label: "Consumer Electronics",
        select: 0,
      },
      {
        label: "Sport",
        select: 0,
      },
    ],
    productAddSuccess:false, // 是否不再显示导入成功弹窗
    selectAgain:false,// 选择不再弹窗
    popoverSort:false,
    isSelectCate:false, // 是否选择类目
  };

  //进入页面调用接口
  componentDidMount() {
    window.onscroll = this.onScroll;
    window.onresize = this.onResize;
    this.onResize();
    document.documentElement.style.scrollBehavior = "smooth";
    if(AppBridge && AppBridge.exist()) {
      AppBridge.setTitleBar('Find Products')
      }
    setTimeout(() => {
      // this.getPreference()
      this.getPageData();
      this.getMenu();
      this.getCounpon();
    }, 0);
  }

  componentWillUnmount() {
    window.onscroll = null;
    window.onresize = null;
  }

  // shouldComponentUpdate(nextProps, nextState) {
  // if (!_.isNil(nextProps.chromePlugins)) {
  //   if (Boolean(Object.keys(nextProps.chromePlugins).length)) {
  //     if (nextProps.chromePlugins !== this.state.checkChromePlugins) {
  //       this.setState({
  //         checkChromePlugins: nextProps.chromePlugins
  //       }, () => {
  //         if (Boolean(this.state.checkChromePlugins.install_check)) {
  //           this.checkGooglePlugin(this.state.checkChromePlugins.id);
  //         }
  //       })
  //     }
  //   }
  //   return true
  // }
  // return true
  // }

  onScroll = () => {
    let obj = document.getElementById("showTopButton");
    if (obj) {
      if (document.documentElement.scrollTop > 250) {
        obj.style.display = "block";
      }
      if (document.documentElement.scrollTop < 250) {
        obj.style.display = "none";
      }
    }
  };

  onResize = () => {
    if (document.body.clientWidth < 1024) {
      this.setState({
        ramadanImage: "/ramadan/banner_mobile.png",
      });
    } else {
      this.setState({
        ramadanImage: "/ramadan/banner.png",
      });
    }
  };

  handleClickRamadan = () => {
    const cateLists = _.cloneDeep(this.state.cateLists);
    const fn = (arr) => {
      _.forEach(arr, (item) => {
        if (!_.isArray(item.children_data)) {
          const list = [];
          _.forIn(item.children_data, (value) => {
            list.push(value);
          });
          item.children_data = list;
          fn(item.children_data);
        }
      });
    };
    fn(cateLists);
    const ramadan = this.filterCateList(cateLists, "Ramadan"); // Ramadan
    this.setState(
      {
        CateValue: ramadan.id || "",
        ProductsTitle: "All Categories ",
        ProductsTitleInfo: ">Holidays & Events>Ramadan",
        page: 1,
        queryValue: "",
      },
      () => {
        // 更新列表数据
        this.getPageData(true);
      }
    );
  };

  // 从类目中获取子节点
  filterCateList = (data, name) => {
    let res = {};
    const fn = (arr) => {
      if (_.isArray(arr)) {
        arr.forEach((item) => {
          if (item.category_name === name) {
            res = item;
          } else if (item.children_data && item.children_data.length > 0) {
            fn(item.children_data, name);
          }
        });
      }
    };
    fn(data);
    return res;
  };

  scrollToTop = () => {
    document.documentElement.scrollTop = 0;
  };

  toggleToast = (showToastText, showToastIserror = false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror,
    }));
  };

  callChargeErrorClosed = () => {
    this.setState({
      chargeError: false,
    },()=>{
      if (!this.state.productAddSuccess && this.state.selectAgain) {
        this.selectAgainClose()
      }
    });
  };
  // 不再弹出导入成功弹窗
  selectAgainClose = async () => {
    let getData = store.getState().languageReducer.subScriptData;
    try {
      let res = await getGetProductAddSuccess()
      if (res.code === '200') {
        this.props.dispatch(changePersonLevel({infoData:{...getData,bfs_pop:{...getData.bfs_pop,is_bfs_import_product:true}}},true))
        this.setState({
          productAddSuccess:true
        })
      }
    } catch (error) {
      
    }
  };

  cateClick = (id, title) => {
    let list = this.state.dataList;
    list.forEach((item) => {
      item.checked = false;
    });

    this.setState(
      {
        CateValue: id,
        ProductsTitle: "All Categories ",
        ProductsTitleInfo: title,
        page: 1,
        queryValue: "",
      },
      () => {
        // 更新列表数据
        this.getPageData(true);
      }
    );
  };
  // 过滤表情
  filterEmoji = (str) => {
    const regex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    return str.replace(regex, "");
  };
  getSeachTitle = () => {
    let list = this.state.dataList;
    list.forEach((item) => {
      item.checked = false;
    });

    let title = "";
    let title_info = "";
    if (this.state.queryValue !== "") {
      title = "All Categories ";
      title_info = '>"' + this.state.queryValue + '"';
    }

    this.setState(
      {
        CateValue: "",
        ProductsTitle: title,
        ProductsTitleInfo: title_info,
        page: 1,
      },
      () => {
        this.getPageData(true);
      }
    );
  };

  // 获取列表数据
  getPageData = async (isSearch = false) => {
    if (isSearch) {
      this.setState({
        isSearching: "1",
        hasPrevious: false,
        hasNext: false,
      });
    } else {
      this.setState({
        loadingPage: true,
        hasPrevious: false,
        hasNext: false,
      });
    }

    const params = {
      q: this.state.queryValue,
      page: this.state.page,
      size: this.state.size,
      sort: this.state.sortBy,
      cate: this.state.CateValue,
    };
    const response = await reqGetFindProductsList(params);
    if (response.code === "200") {
      let getData = response.data;
      let person = store.getState().languageReducer.subScriptData;
      if (Object.values(person).length > 0) {
        this.setState({
          productAddSuccess:person?.bfs_pop?.is_bfs_import_product ? person?.bfs_pop?.is_bfs_import_product : false
        })
      }
      let res = await reqGetUserSubcribe();
      if (res.code === "200") {
        this.setState({
          importantLimit: Number(res?.data?.limit?.dsm),
          importantDay: Number(res?.data?.day?.dsm_product_num),
        });
      }
      // let timer = setInterval(() => {
      //   if(Boolean(Object.keys(this.state.checkChromePlugins).length)) {
      //     clearInterval(timer)
      //     this.setState({
      //       loadingPage: false
      //     })
      //   }
      // }, 100)
      this.setState(
        {
          loadingPage: false,
          pageData: getData.result,
          holidayBanner: getData.banners,
          total: getData.count,
          ShowCountNumber: getData.count,
          isSearching: "0",
          pageValue: "",
          isCate: Number(getData.select_cate) === 1 ? true : false,
          cateSelectData: getData.category,
        },
        () => {
          // 更新列表数据
          this.updatePageDetail();
        }
      );

      // 更新分页数据
      if (this.state.page > 1) {
        this.setState({
          hasPrevious: true,
        });
      } else {
        this.setState({
          hasPrevious: false,
        });
      }

      const maxPage = Math.ceil(response.data.count / this.state.size);
      if (this.state.page < maxPage) {
        this.setState({
          hasNext: true,
          PageCount: maxPage,
          total:response.data.count
        });
      } else {
        this.setState({
          hasNext: false,
          PageCount: maxPage,
          total:response.data.count
        });
      }
    } else {
      this.toggleToast(response.msg);
      // let timer = setInterval(() => {
      //   if(Boolean(Object.keys(this.state.checkChromePlugins).length)) {
      //     clearInterval(timer)
      //     this.setState({
      //       loadingPage: false
      //     })
      //   }
      // }, 100)
      this.setState({
        loadingPage: false,
        pageData: [],
        isSearching: "0",
      });
    }

    // 清除浏览器链接上的参数
    try {
      var currentUrl = window.location.href;
      if (currentUrl.indexOf("?") !== -1) {
        currentUrl = currentUrl.replace(/(\?|#)[^'"]*/, "");
        if (!!(window.history && window.history.pushState)) {
          window.history.pushState({}, 0, currentUrl);
        }
      }
    } catch (error) {
      console.warn(error);
    }
  };

  getMenu = async () => {
    const response = await reqGetFindProductsMenu();

    let cate_list = Object.values(response.data);
    let dataMenu = [];

    cate_list.map((key, value) => {
      return dataMenu.push({
        id: key.id,
        key: key.category_name,
        img: key.featured_image,
        checked: false,
      });
    });
    this.setState({
      cateLists: cate_list,
      dataList: dataMenu,
    });
  };

  getPreference = async () => {
    const response = await reqPreference();

    if (response.type === 0) {
      this.setState({
        showUserPreferences: true,
      });
    }
  };

  // 更新列表信息
  updatePageDetail() {
    let data = this.state.pageData;
    let listHtmlContent = <div></div>;
    if (data.length > 0) {
      listHtmlContent = data.map((item, key) => {
        let imageUrl = "/default_image.png";
        if (item.image_url !== "" && typeof item.image_url !== "object") {
          imageUrl = item.image_url;
        }

        let discountRangeClass = "";
        let compared_price = item.compared_price;
        let discount_rate = item.discount_rate;

        if (discount_rate !== 0 && compared_price !== "") {
          let split = compared_price.split("-");
          if (split.length === 2) discountRangeClass = "discountRange";
        }

        return (
          <div className="Product_Card_Tkabk find_product" key={key}>
            <div className={"buttonHover " + discountRangeClass}>
              <Card padding={0}>
                <div
                  className="Product_Image_Wrapper Product_Cover_Tkabk"
                  style={{ width: "246px", height: "246px" }}
                >
                  <div
                    onClick={() => this.handleJumpToDetail(item.id)}
                    style={{ cursor: "pointer", width: "100%", height: "100%" }}
                  >
                    <LazyLoad once>
                      <img
                        src={imageUrl}
                        alt=""
                        onClick={() => {
                          //Search Product页面产品封面点击gtag
                          reqGoogleAnalytics(
                            "click",
                            "searchproduct_productpicture_click"
                          );
                        }}
                      />
                    </LazyLoad>
                  </div>
                  {discount_rate > 0 ? (
                    <div className="discount">{"-" + discount_rate + "%"}</div>
                  ) : (
                    ""
                  )}
                </div>

                <div style={{ padding: "20px" }}>
                  <div className="Product_Title_tkabk" title={item.title}>
                    {item.title}
                  </div>
                  <div style={{ margin: "10px 0" }}>
                    <InlineStack align="space-between">
                      <span className="Product_Rating_tkabk">
                        <svg viewBox="0 0 20 20">
                          <path d="M5.2 18a.8.8 0 0 1-.792-.914l.743-5.203-2.917-2.917a.8.8 0 0 1 .434-1.355l4.398-.733 2.218-4.435a.8.8 0 0 1 1.435.008l2.123 4.361 4.498.801a.8.8 0 0 1 .425 1.353l-2.917 2.917.744 5.203a.8.8 0 0 1-1.154.828l-4.382-2.22-4.502 2.223A.792.792 0 0 1 5.2 18z"></path>
                        </svg>
                        {item.rating + " (" + item.evaluation_count + ")"}
                      </span>
                      <span className="Product_Orders_tkabk">
                        <svg viewBox="0 0 20 20">
                          <path d="M11 1a1 1 0 1 0-2 0v7.586L7.707 7.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 8.586V1z"></path>
                          <path d="M3 14V3h4V1H2.5A1.5 1.5 0 0 0 1 2.5v15A1.5 1.5 0 0 0 2.5 19h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 17.5 1H13v2h4v11h-3.5c-.775 0-1.388.662-1.926 1.244l-.11.12A1.994 1.994 0 0 1 10 16a1.994 1.994 0 0 1-1.463-.637l-.111-.12C7.888 14.664 7.275 14 6.5 14H3z"></path>
                        </svg>
                        {" " + item.order_count}
                      </span>
                    </InlineStack>
                  </div>
                  <div className="Product_Price_Value">
                    <div className="Product_Title_Money">{item.price}</div>

                    {compared_price && (
                      <div className="Product_Compare_at_price_tkabk">
                        {"(" + compared_price + ")"}
                      </div>
                    )}
                  </div>
                </div>
                <Box>
                  <div className="Place_Order_Button">
                    {item.pid ? (
                      <Button
                        id={"btn2"}
                        onClick={() =>
                          this.handleToSourcingList(key, item.id, item.pid)
                        }
                        fullWidth
                      >
                        {intl.get("Edit on product list")}
                      </Button>
                    ) : (
                      <Button
                        id={"btn1"}
                        onClick={() =>
                          this.handleToSourcingList(key, item.id, 0)
                        }
                        fullWidth
                        variant="primary"
                        loading={!!item.loading}
                      >
                        <InlineStack blockAlign="center">
                       <Icon
                        source={AddMajor}
                        tone="base"
                      /> {intl.get("Add to product list")}
                      </InlineStack>
                      </Button>
                    )}
                  </div>
                </Box>
              </Card>
            </div>
          </div>
        );
      });
    }

    this.setState({
      ListDivHtml: listHtmlContent,
      ShowCountNumber: data.length,
    });
  }

  // 页面操作
  handleToSourcingList = async (recordKey, productId, userProductId) => {
    if (userProductId !== 0) {
      // 跳转到sourcing - product 页面
      utils.routeListen("/admin/import-list");
      utils.routeJump(this, "/admin/import-list?ids=" + userProductId);
      return;
    } else {
      let person = store.getState().languageReducer.subScriptData;
      // 导入限制
      if ((person?.level === 0 && this.state.importantLimit >= 3) ||  (person?.level ===4 && this.state.importantLimit >= 100)) {
        this.setState({ importantDsmModal: true });
        return;
      }

      //Search Product页面Add to products list按钮点击gtag
      reqGoogleAnalytics("click", "searchproduct_importproduct_click");

      // 产品导入到 sourcing - product列表
      let data = this.state.pageData;
      data[recordKey].loading = 1;
      this.setState(
        {
          pageData: data,
        },
        () => {
          this.updatePageDetail();
        }
      );

      const params = {
        id: productId,
      };
      const response = await reqPostAddProductToList(params);
      if (response.code === "200") {
        this.setState({ importantLimit: this.state.importantLimit + 1 });
        data[recordKey].pid = response.data;
        data[recordKey].loading = 0;

        this.setState(
          {
            pageData: data,
            chargeError:this.state.productAddSuccess ? false : true,
          },
          () => {
            if (this.state.productAddSuccess) {
              this.toggleToast('Added successfully')
            } 
            this.updatePageDetail();
          }
        );
      } else {
        store.dispatch(changeBannerData({bannerData:{
          show:true,
          desc:response.msg
        }}));
      }
    }
  };

  /**
   * 判断链接跳转
   *
   * 说明：如果 AppBridge实例存在代表Shopify内嵌模式，否在代表Shopify站外访问
   *
   * @param {string} uri 路由，没有携带域名
   */
  handleJumpLink = (uri) => {
    if (AppBridge.exist()) {
      utils.routeListen(uri);
      utils.routeJump(this, uri);
    } else {
      try {
        // 获取当前域名
        // let localHost =
        //   window.location.protocol +
        //   "//" +
        //   window.location.hostname +
        //   (window.location.port ? ":" + window.location.port : "");

        // const w = window.open("about:blank");
        // w.location.href = localHost + uri;
        utils.routeListen(uri);
        utils.routeJump(this, uri);
      } catch (error) {
        utils.routeListen(uri);
        utils.routeJump(this, uri);
      }
    }
  };

  // 跳转到产品详情页面
  handleJumpToDetail = (id) => {
    this.handleJumpLink("/admin/find_products/product-info?filter=" + id);
    return false;
  };

  // select change
  handleSelectChange = (value) => {
    // let list = this.state.dataList;
    // list.forEach(item=>{
    //   item.checked = false;
    // })
    this.setState(
      {
        sortBy: value[0],
        page: 1,
        // CateValue:"",
        queryValue: "",
        // ProductsTitleInfo:"",
        // ProductsTitle:"",
      },
      () => {
        setTimeout(() => {
          this.getPageData(true);
        }, 600);
      }
    );
  };

  AllCategoiresClick = () => {
    let list = this.state.dataList;
    list.forEach((item) => {
      item.checked = false;
    });
    this.setState(
      {
        sortBy: "order_desc",
        CateValue: "",
        queryValue: "",
        page: 1,
        ProductsTitleInfo: "",
      },
      () => {
        this.getPageData(true);
      }
    );
  };

  // 搜索输入
  handleFiltersQueryChange = (value) => {
    this.setState({
      queryValue: this.filterEmoji(value),
      page: 1,
    });
  };

  // 浏览器url请求参数处理
  handleBrowserLink = (cateStr) => {
    try {
      var currentUrl = window.location.href;
      currentUrl = currentUrl.replace(/(\?|#)[^'"]*/, "");
      if (cateStr) {
        currentUrl = currentUrl + "?cat=" + cateStr;
      }

      if (!!(window.history && window.history.pushState)) {
        window.history.pushState({}, 0, currentUrl);
      }
    } catch (error) {
      // console.warn(error);
    }
  };

  itemClick = (item, index) => {
    
    //Search products页面类目按钮点击
    reqGoogleAnalytics("click", "searchproduct_categories_click");

    let list = this.state.dataList;
    let CateValue = "";
    if (list[index].checked === true) {
      list[index].checked = false;
      this.setState({
        isSelectCate:false,
        ProductsTitle: "",
        ProductsTitleInfo: "",
      });
    } else {
      list.forEach((item) => {
        item.checked = false;
      });
      list[index].checked = true;
      this.setState({
        isSelectCate:true,
        ProductsTitle: "All Categories ",
        ProductsTitleInfo: ">" + list[index].key,
      });
      CateValue = list[index].id;
    }

    this.setState(
      {
        dataList: list,
        queryValue: "",
        CateValue: CateValue,
        page: 1,
      },
      () => {
        // 更新列表数据
        this.getPageData(true);
      }
    );
  };

  togglePopoverActive = () => {
    this.setState({
      togglePopoverActive: !this.state.togglePopoverActive,
    });
  };

  callBackCloseModal = (data) => {
    let setParams = {};
    if (data.type) {
      setParams.ProductsTitle = "All Categories ";
    }
    setParams.showUserPreferences = false;

    this.setState(setParams);
  };

  callCouponModalClosed = () => {
    this.setState({
      CouponModal: false,
    });
  };

  getCounpon = async () => {
    let response = await reqGetCoupon();

    if (response.code === 200 && response.data.length > 0) {
      this.setState({
        CouponData: response.data,
        CouponModal: true,
      });
    }
  };

  getReceiveCounpon = async (key) => {
    let list = this.state.CouponData;

    if (list[key].display === false || !list[key]) {
      return false;
    }

    list[key].display = false;

    let response = await reqReceiveCoupon({
      id: list[key].id,
      tokens: list[key].tokens,
    });

    if (response.code === 200) {
      this.setState({
        CouponData: list,
      });
      this.toggleToast(response.msg, false);
    } else {
      this.toggleToast(response.msg);
    }
  };

  // 检测谷歌插件
  checkGooglePlugin = (id) => {
    var image = document.createElement("img");
    let _this = this;
    // 必须要启用该插件才可用
    image.src = `chrome-extension://${id}/logo128.png`;
    image.onload = function () {
      _this.setState({
        loadingPage: false,
        GooglePluginInstall: true,
      });
    };
    image.onerror = function () {
      _this.setState({
        loadingPage: false,
        GooglePluginInstall: false,
      });
    };
  };

  // 切换谷歌插件弹窗开关
  handleCheckGooglePluginModal = () => {
    this.setState(({ CheckGooglePluginActive }) => ({
      CheckGooglePluginActive: !CheckGooglePluginActive,
    }));
  };

  // 跳转Url
  jumpUrl = (url) => {
    try {
      window.open(url);
      this.handleCheckGooglePluginModal();
    } catch (error) {
      console.log(error);
    }
  };

  // sourcing from 1688的点击事件
  sourcingFrom1688Click = (id) => {
    this.checkGooglePlugin(id);
    this.handleCheckGooglePluginModal();
  };

  // 非会员阻断浏览trendy商品限制
  handleToTrendyProduct = (type) => {
    // let person = Object.values(this.props.subScriptData).length > 0 ? this.props.subScriptData : store.getState().languageReducer.subScriptData;
    let person = store.getState().languageReducer.subScriptData;
    switch (type) {
      case "trendy":
        if (person?.level >= 2 && person?.level !==4) {
          utils.routeListen("/admin/find_products/trendy-products/trendy");
          utils.routeJump(this, "/admin/find_products/trendy-products/trendy");
        } else {
          this.setState({ upgradeModal: true });
        }
        break;
      case "winning":
        if (person?.level >= 2 && person?.level !==4) {
          utils.routeListen(
            "/admin/find_products/recommended-category/winning"
          );
          utils.routeJump(
            this,
            "/admin/find_products/recommended-category/winning"
          );
        } else {
          this.setState({ upgradeModal: true });
        }

        break;

      default:
        break;
    }
  };

  // 偏好选择
  handleChangeSelect = (value) => {
    let list = this.state.cateSelectData.map((item, ind) => {
      if (item.value === value) {
        return { ...item, select: item?.select === 1 ? 0 : 1 };
      } else {
        return item;
      }
    });
    let len = list.filter((sl) => {
      return sl.select === 1;
    });
    if (len.length <= 5) {
      this.setState({
        cateSelectData: list,
      });
    } else {
      this.setState({
        warningMessage:'Maximum 5 categories allowed'
      })
      // this.toggleToast("Maximum 5 categories allowed", true);
    }
  };
  // 保存选择
  onSubmitSelect = async () => {
    let len = this.state.cateSelectData.filter((sl) => {
      return sl.select === 1;
    });
    if (len.length > 0) {
      let ids = [];
      for (let i = 0; i < len.length; i++) {
        if (len[i].select === 1) {
          ids.push(len[i].value);
        }
      }
      let params = {
        cate_ids: ids,
      };
      try {
        let res = await getPostCateSelect(params);
        if (res.code === "200") {
          this.toggleToast('Added successfully');
          this.setState({
            warningMessage:''
          })
          this.setState({
            isCate: false,
          },()=>{
            this.getPageData()
          });
        }
      } catch (error) {}
    } else {
      this.setState({
        warningMessage:'Please select at least one category'
      })
      // this.toggleToast("Please select at least one category.", true);
    }
  };

  // 取消
  onCancelSelect = async () => {
    this.setState({
      warningMessage:''
    })
    let list = this.state.cateSelectData.map((item, ind) => {
      return { ...item, select: 0 };
    });
    try {
      let params = {
        cate_ids: [],
      };
      let res = await getPostCateSelect(params);
      if (res.code === "200") {
        this.setState({
          cateSelectData: list,
          isCate: false,
        });
      }
    } catch (error) {}
  };
  render() {
    const toastMarkup = this.state.showToast ? (
      <Toast
        content={this.state.showToastText}
        onDismiss={() => this.toggleToast("")}
        error={this.state.showToastIserror}
        duration={1500}
      />
    ) : null;
    const {
      isSearching,
      ShowCountNumber,
      ListDivHtml,
      CheckGooglePluginActive,
      GooglePluginInstall,
      holidayBanner,
      warningMessage
    } = this.state;

    const initSkeletonPage = (
      <div>
        <SkeletonPage fullWidth={true}>
          <Layout>
            <Layout.Section>
              <Card>
                <BlockStack gap={400}>
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                  <SkeletonBodyText lines={3} />
                </BlockStack>
              </Card>
            </Layout.Section>
          </Layout>
        </SkeletonPage>
      </div>
    );

    const EmptyProductList =
      ShowCountNumber === 0 ? (
        <div style={{ textAlign: "center", marginTop: "100px" }}>
          <p style={{ fontSize: "20px", opacity: "1", marginBottom: "35px" }}>
            {intl.get("Sorry! We couldn't find the product that you searched.")}
          </p>
          <p style={{ fontSize: "20px", opacity: "1", marginBottom: "35px" }}>
            {intl.get(
              "Please check your spelling or search by other associated keywords"
            )}
          </p>
          <p style={{ fontSize: "20px", opacity: "1", marginBottom: "0" }}>
          {intl.get("Or you can")}
            <span
              className="Polaris-Link"
              onClick={() => {
                utils.routeListen("/admin/sourcing");
                utils.routeJump(this, "/admin/sourcing");
              }}
              style={{ textDecoration: "none" }}
            >
              {" "}
              {intl.get("send a sourcing request.")}
            </span>
          </p>
        </div>
      ) : (
        ""
      );

    const sortOptions = [
      { label: intl.get("Newest to oldest"), value: "time_asc" },
      { label: intl.get("Rating:high to low"), value: "rating_desc" },
      { label: intl.get("Price:low to high"), value: "price_asc" },
      { label: intl.get("Price:high to low"), value: "price_desc" },
    ];

    var footerContentMsg = "";
    if (this.state.total > 0) {
      const startNum = (this.state.page - 1) * this.state.size + 1;
      const endNum =
        this.state.page * this.state.size > this.state.total
          ? this.state.total
          : this.state.page * this.state.size;
      // footerContentMsg = <div className="Pagination_Result__Footer">{"Showing " + startNum + " - "+ endNum + " of " + this.state.total + " results"}</div>;
      footerContentMsg = (
        <div>
          {intl.get(
            "Showing {{startNum}} - {{endNum}} of {{total}} results (Total {{PageCount}} pages)",
            startNum,
            endNum,
            this.state.total,
            this.state.PageCount
          )}
        </div>
      );
      // console.log(this.state.total,this.state.PageCount);
    }

    const PaginationSettings = this.state.loadingPage ? (
      ""
    ) : ShowCountNumber !== 0 ? (
      <div className="Polaris-New-Pagination">
        <Pagination
          label={footerContentMsg}
          hasPrevious={this.state.hasPrevious}
          onPrevious={() => {
            this.setState({ page: Number(this.state.page) - 1 }, () => {
              this.getPageData(true);
            });
          }}
          hasNext={this.state.hasNext}
          onNext={() => {
            this.setState({ page: Number(this.state.page) + 1 }, () => {
              this.getPageData(true);
            });
          }}
        />
        <div>
          <input
            className="Page_input"
            type="text"
            value={this.state.pageValue}
            maxLength={"8"}
            onChange={(e) => {
              if (Number.isInteger(Number(e.target.value))) {
                this.setState({
                  pageValue: e.target.value,
                });
              }
            }}
          />
          <span
            className="Page_Jump"
            onClick={() => {
              if (this.state.PageCount === 1) return false;
              let page = 1;
              if (this.state.pageValue > this.state.PageCount) {
                page = this.state.PageCount;
              }
              if (
                this.state.pageValue > 1 &&
                this.state.pageValue <= this.state.PageCount
              ) {
                page = this.state.pageValue;
              }

              this.setState(
                {
                  page: page,
                },
                () => {
                  this.getPageData(true);
                }
              );
            }}
          >
           {intl.get("Go to")}
          </span>
        </div>
      </div>
    ) : (
      ""
    );

    // 控制列表两个产品之间间距显示
    let smallSpacingClass = ShowCountNumber <= 4 ? "small_spacing" : "";

    const SingleOperationTipsModal = (
      <Modal
        open={this.state.chargeError}
        onClose={this.callChargeErrorClosed}
        title={intl.get("Product imported successfully")}
      >
        <Box className='product_success_content'>
          <div style={{ fontSize: "16px", color: "#202223",padding:"16px" }}>
            {intl.get("You can go to the")}{" "}
            <span style={{ fontSize: "16px",fontWeight:700, color: "#303030" }}>
              {intl.get("List Products > Not Listed")}
            </span>{" "}
            {intl.get("to view and edit the product.")}
          </div>
          
          <Box className='product_success_button'>
          <Checkbox
                checked={this.state.selectAgain}
                label={intl.get("Don't remind me again")}
                onChange={()=>this.setState(({
                  selectAgain:!this.state.selectAgain
                }))}
              />
            <Button variant="primary" onClick={this.callChargeErrorClosed}>
            {intl.get("OK")}
            </Button>
          </Box>
        </Box>
      </Modal>
    );

    const cateMenuInfo =
      this.state.MenuId !== "" ? (
        <div className="menu-cont">
          <div className="menu-cont-list">
            <ul>
              {this.state.MenuId.map((k, v) => {
                return (
                  <li
                    key={"menu_two_title" + v}
                    onClick={() => {
                      this.cateClick(
                        k.id,
                        ">" + this.state.Child + " >" + k["category_name"]
                      );
                    }}
                  >
                    <span>{k["category_name"]}</span>
                    <div className="menu-list-link"></div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      ) : (
        ""
      );

    let clientWidth = document.documentElement.clientWidth;
    let SlidePercentage = 100;
    switch (true) {
      case clientWidth <= 1024:
        SlidePercentage = 100;
        break;

      case clientWidth > 1024 && clientWidth <= 1440:
        SlidePercentage = 30;
        break;

      case clientWidth > 1440:
        SlidePercentage = 20;
        break;

      default:
    }

    // 轮播组件全局配置
    const globalConfig = {
      autoPlay: false,
      interval: 5000,
      selectedItem: 1,
      showArrows: true,
      showIndicators: false,
      showStatus: false,
      infiniteLoop: true,
      showThumbs: false,
      centerMode: true,
      centerSlidePercentage: SlidePercentage,
    };

    // 轮播按钮样式
    // const arrowStyles = {
    //   position: "absolute",
    //   zIndex: 2,
    //   top: "calc(50% - 15px)",
    //   width: 30,
    //   height: 30,
    //   cursor: "pointer",
      
    // };
    // 轮播组件全局配置
    const globalConfigs = {
      autoPlay: true,
      interval: 5000,
      showArrows: true,
      showIndicators: holidayBanner.length > 0 ? true : false,
      showStatus: false,
      infiniteLoop: true,
      showThumbs: false,
    };
    const pageContent = this.state.loadingPage ? (
      initSkeletonPage
    ) : (
      <section>
        {/* 下架 */}
        {/* <div className='Polaris-Page Polaris-Page--fullWidth'>
          <div className='ramadan' onClick={this.handleClickRamadan}>
            <img src={this.state.ramadanImage} alt='ramadan' />
          </div>
        </div> */}
        <Page
          // title={intl.get('Search Product')}
          // subtitle={intl.get(
          //   'A large number of good goods from Dropshipman to meet all your needs'
          // )}
          fullWidth
          // primaryAction={
          //   <Button plain onClick={() => this.props.history.push('/admin/calculate-shipping')}>
          //     {intl.get('Freight calculation')}
          //   </Button>
          // }
        >
          <Layout>
            <Layout.Section>
              {holidayBanner.length > 0 && (
                <div className="holiday_banner">
                  <Carousel {...globalConfigs}>
                    {holidayBanner.map((item, ind) => (
                      <div
                        key={ind}
                        onClick={
                          () => {
                            if (item.url === 'spring-festival') {
                              window.open('https://www.dropshipman.com/blog/dropshipman-2024-chinese-new-year-notice','_blank')
                            }else{
                            utils.routeListen(
                              "/admin/find_products/holiday-products"
                            );
                            utils.routeJump(
                              this,
                              "/admin/find_products/holiday-products?holiday=" +
                                item.url
                            );
                            }
                          }
                        }
                        className="holiday_item"
                        // style={{ backgroundImage: `url(${item.src})` }}
                      >
                        <img style={{maxWidth: '100%'}} src={item.src} alt="holiday" />
                      </div>
                    ))}
                  </Carousel>
                </div>
              )}
              {AppBridge.exist() ? '' : <div className="search_product_head">
                <div className="search_product_head_h1">
                  <h1>{intl.get("Find Products")}</h1>
                  <p>
                    {intl.get(
                      "Dropshipman brings you a world of fantastic products right to your doorstep!"
                    )}
                  </p>
                </div>
                {/* <div className="search_product_head_button">
                  <Button
                    variant="primary"
                    onClick={() =>
                      this.props.history.push("/admin/customService/calculate-shipping")
                    }
                  >
                    {intl.get("Freight calculation")}
                  </Button>
                </div> */}
              </div>}
              <Box className='cate_box_list'>
              <div className="cate_list">
                <div
                  className="cate_img"
                  onMouseEnter={(e) => {
                    this.setState({
                      togglePopoverActive: !this.state.togglePopoverActive,
                    });
                  }}
                  onMouseLeave={(e) => {
                    this.setState({
                      togglePopoverActive: !this.state.togglePopoverActive,
                    });
                  }}
                >
                  <img src={"/meau_list.jpg"} alt="" />
                  {this.state.togglePopoverActive && (
                    <div
                      className="box_div"
                      onMouseLeave={() => {
                        this.setState({
                          MenuId: "",
                        });
                      }}
                    >
                      <div className="box">
                        <div className="mod-menu">
                          <ul className="menu-item">
                            <li
                              onClick={() => {
                                this.AllCategoiresClick();
                              }}
                            >
                              <span>
                                <h2 className="title_first_info">
                                  {intl.get("All Categories")}
                                </h2>
                              </span>
                            </li>
                            {this.state.cateLists.map((key, value) => {
                              return (
                                <li
                                  key={"cateInfo" + value}
                                  onMouseEnter={() => {
                                    this.setState({
                                      Child: key["category_name"],
                                      MenuId: key.hasOwnProperty(
                                        "children_data"
                                      )
                                        ? Object.values(key.children_data)
                                        : [],
                                    });
                                  }}
                                  onClick={() => {
                                    this.cateClick(
                                      key.id,
                                      ">" + key["category_name"]
                                    );
                                  }}
                                >
                                  <h3>
                                    <span>{key["category_name"]}</span>
                                  </h3>
                                </li>
                              );
                            })}
                          </ul>

                          {cateMenuInfo}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div
                  className="input_search_div"
                  style={{
                    flex: 1,
                    margin: "0 20px 0 0",
                    position: "relative",
                  }}
                >
                  <input
                    type="text"
                    placeholder={intl.get("Clothing") + "..."}
                    autoComplete="off"
                    maxLength="100"
                    value={this.state.queryValue}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        this.getSeachTitle();
                      }
                    }}
                    className="search_input"
                    onChange={(e) => {
                      this.handleFiltersQueryChange(e.target.value);
                    }}
                  />
                  <div
                    className="search_input_img"
                    onClick={() => {
                      this.getSeachTitle();
                    }}
                  >
                    <img src={"/loupe.png"} alt="" />
                  </div>

                  {false && (
                    <div className="search_input_img_camera">
                      <label>
                        <div>
                          <img src={"/camera.png"} alt="" />
                        </div>
                        <input
                          type="file"
                          ref={"myRef"}
                          id="file-input"
                          accept=".jpg,.jpeg,.png"
                          onChange={async (e) => {
                            this.setState({
                              SeachImage: true,
                              Imageload: true,
                            });
                            let formData = new FormData();
                            formData.append("file", e.target.files[0]);
                            const response = await reqFileMapSearch(formData);
                            e.target.value = "";
                            this.setState({
                              SeachImage: false,
                              Imageload: false,
                            });
                            utils.routeListen("/admin/search/image");
                            utils.routeJump(
                              this,
                              "/admin/search/image?result=" +
                                response.data.list +
                                "&url=" +
                                response.data.url
                            );
                          }}
                          style={{ display: "none" }}
                        />
                      </label>
                    </div>
                  )}
                </div>

                <div className="search_input_sort">
                <Popover
                  active={this.state.popoverSort}
                  activator={
                     <Button onClick={()=>this.setState({popoverSort:true})}>
                      <InlineStack blockAlign="center">
                  <Icon
                    source={SortMinor}
                    tone="base"
                  />
                 <span>{intl.get("Sort")}</span>
                  </InlineStack>
                  </Button>
                  }
                  autofocusTarget="first-node"
                  onClose={()=>this.setState({popoverSort:false})}
                >
                  <OptionList
                  title=""
                  onChange={this.handleSelectChange}
                  options={sortOptions}
                  selected={[this.state.sortBy]}
                />
                </Popover>
                </div>
              </div>
              </Box>
              {/* 三个标签入口 */}
              <div className="space"></div>
              <Layout>
                <Layout.Section variant="oneThird">
                  <section
                    className="recommend_category explosive"
                    onClick={() => this.handleToTrendyProduct("trendy")}
                  >
                    <div className="sign_left">
                      <img src="/popular.png" alt="Dropshipman" />
                    </div>
                    <div className="title">{intl.get("Trendy Products")}</div>
                    <div
                      className="sign_right"
                      style={{
                        background: "#fff",
                        borderRadius: "50%",
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img src="/sub/sub_head_2.png" alt="Dropshipman" />
                    </div>
                  </section>
                </Layout.Section>

                <Layout.Section variant="oneThird">
                  <section
                    className="recommend_category winning"
                    onClick={() => this.handleToTrendyProduct("winning")}
                  >
                    <div className="sign_left">
                      <img src="/diamond.png" alt="" />
                    </div>
                    <div className="title">{intl.get("Winning Products")}</div>
                    <div
                      className="sign_right"
                      style={{
                        background: "#fff",
                        borderRadius: "50%",
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <img src="/sub/sub_head_2.png" alt="Dropshipman" />
                    </div>
                  </section>
                </Layout.Section>
                <Layout.Section variant="oneThird">
                  <section
                    className="recommend_category discount"
                    // onClick={() => this.props.history.push('/admin/find_products/recommended-category/discount')}
                    onClick={
                      () => {
                        utils.routeListen(
                          "/admin/find_products/holiday-products"
                        );
                        utils.routeJump(
                          this,
                          "/admin/find_products/holiday-products"
                        );
                      }
                      // this.props.history.push("/admin/find_products/holiday-products")
                    }
                  >
                    <div className="sign_left">
                      <img src="/dream_product.png" alt="Dropshipman" />
                    </div>
                    <div className="title">{intl.get("Event Products")}</div>
                    <div className="sign_right">
                      <img src="/gift_product.png" alt="Dropshipman" />
                    </div>
                  </section>
                </Layout.Section>
              </Layout>

              {/* 商品分类 */}
              <div className="space"></div>
              <section className="dropshipman_category">
                <Carousel
                  {...globalConfig}
                  renderArrowNext={(onClickHandler, hasNext, label) =>
                    hasNext && (
                      <div
                        className={this.state.isSelectCate ? "arrow_button_right_select arrow_button_right " : "arrow_button_right "}
                        onClick={onClickHandler}
                        title={label}
                      >
                        <span className="cate_chevron_right">
                        <Icon
                            source={ChevronRightMinor}
                            tone="base"
                          />
                        </span>
                      </div>
                    )
                  }
                  renderArrowPrev={(onClickHandler, hasPrev, label) =>
                    hasPrev && (
                      <div
                        className={"arrow_button_left"}
                        onClick={onClickHandler}
                        title={label}
                      >
                        <span className="cate_chevron_left">
                        <Icon
                          source={ChevronLeftMinor}
                          tone="base"
                        />
                        </span>
                      </div>
                    )
                  }
                >
                  {Object.keys(this.state.dataList).map((key, value) => {
                    return (
                      <div
                        key={"dataList_" + value}
                        onClick={this.itemClick.bind(this, key, value)}
                        className={
                          this.state.dataList[key]["checked"]
                            ? "dropshipman_category_item selected"
                            : "dropshipman_category_item"
                        }
                      >
                        {this.state.dataList[key]["checked"] && (
                          <div className="icon-img-content-gou">
                            <span>
                            <Icon
                                source={TickMinor}
                                tone="base"
                              />
                            </span>
                          </div>
                        )}
                        <div className="_img">
                          <img
                            className="icon-img-content"
                            src={this.state.dataList[key]["img"]}
                            alt=""
                          />
                        </div>

                        <div>{this.state.dataList[key]["key"]}</div>
                      </div>
                    );
                  })}
                </Carousel>
              </section>

              {/* 数据为空显示 */}
              <div style={{ position: "relative" }}>
                {EmptyProductList}

                <div
                  className="Product__Loading"
                  style={{
                    display:
                      isSearching === "1" && ShowCountNumber === 0
                        ? "block"
                        : "none",
                    backgroundColor: "unset",
                  }}
                >
                  <div className="Product__Loading_Image">
                    <img
                      style={{
                        width: "32px",
                        height: "32px",
                        verticalAlign: "middle",
                      }}
                      src="/loading.gif"
                      alt="loading"
                    />
                  </div>
                </div>
              </div>

              <div
                className="Products_top"
                style={{ display: ShowCountNumber > 0 ? "block" : "none" }}
              >
                {this.state.ProductsTitle ? (
                  <span
                    className={"Products_title"}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.AllCategoiresClick();
                    }}
                  >
                    {" "}
                    {this.state.ProductsTitle}{" "}
                  </span>
                ) : (
                  <span className={"Products_title"}> {intl.get("Recommend")} </span>
                )}

                <span className={"Products_title_info"}>
                  {this.state.ProductsTitleInfo || this.state.ProductsTitle
                    ? this.state.ProductsTitleInfo
                    : intl.get("(Recommend to you based on your search preferences)")}
                </span>
              </div>

              {/* Start: Find products 列表 */}
              <div style={{ position: "relative" }}>
                <section className="Product_Resource_Wrapper">
                  <div className="Border_Mask Left"></div>
                  <div className="Border_Mask Right"></div>
                  <div className="Border_Mask Bottom"></div>

                  <div
                    className={
                      "Product_Resource_Container " + smallSpacingClass
                    }
                  >
                    {/* 列表 div 对象 */}
                    {ListDivHtml}
                  </div>
                </section>

                <div
                  className="Product__Loading"
                  style={{
                    display:
                      isSearching === "1" && ShowCountNumber > 0
                        ? "block"
                        : "none",
                  }}
                >
                  <div className="Product__Loading_Image">
                    <img
                      style={{
                        width: "32px",
                        height: "32px",
                        verticalAlign: "middle",
                      }}
                      src="/loading.gif"
                      alt="loading"
                    />
                  </div>
                </div>
              </div>
              {/* End: 列表 */}

              {/* 分页 */}
              {PaginationSettings}
            </Layout.Section>
          </Layout>
        </Page>
      </section>
    );

    // 返回顶部按钮
    const RoundButton = (
      <Link onClick={this.scrollToTop} external={false}>
        <div className="top_position">
          <div>
            <img
              src={"/xiangshang.png"}
              style={{ width: "35px", height: "35px" }}
              alt=""
            />
          </div>
        </div>
      </Link>
    );
    // 优惠券弹窗
    const CouponPopModal = (
      <Modal open={this.state.CouponModal} onClose={this.callCouponModalClosed}>
        {/* <Modal.Section> */}
        <div style={{ background: "#f1f1f1", padding: "2rem" }}>
          <div className="coupon_title">
           {intl.get("Congratulations on getting the coupon")}
          </div>
          <div className="coupon_title_tips">{intl.get("Coupons help you save more")}</div>

          {this.state.CouponData.map((item, key) => {
            return (
              <div
                className="coupon_list"
                key={"coupon" + key}
                style={{
                  backgroundImage: "url(/blackFriday/coupon_bg_new.png)",
                  width: "80%",
                }}
              >
                <div className="coupon_list_pop">
                  <div className="coupon_pop_left">
                    <div className="coupon_pop_text">
                      <span className="coupon_pop_text_span">
                        ${item.money} USD{" "}
                      </span>
                      <span className="coupon_pop_text_span_two">
                      {intl.get("Available for Dropshipman orders")}
                      </span>
                    </div>
                    <div className="coupon_pop_text_bottom">
                    {intl.get("Orders over $ {{full_money}} USD",item.full_money)} |{" "}
                      {moment(item.start_time * 1000)
                        .locale("en")
                        .format("LL") +
                        " - " +
                        moment(item.end_time * 1000)
                          .locale("en")
                          .format("LL")}{" "}
                    </div>
                  </div>

                  <div className="coupon_pop_right">
                    {item.display ? (
                      <Button
                        id="coupon_pop_button1"
                        onClick={() => {
                          this.getReceiveCounpon(key);
                        }}
                      >
                        {intl.get("Claim")}
                      </Button>
                    ) : (
                      <Button
                        id="coupon_pop_button2"
                        disabled={true}
                        onClick={() => {
                          this.getReceiveCounpon(key);
                        }}
                      >
                        {intl.get("Claim")}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {/* </Modal.Section> */}
      </Modal>
    );

    // 偏好选择弹窗
    const CateSelectPopModal = (
      <Modal
        open={this.state.isCate}
        title={intl.get("Select your recommended picks")}
        onClose={()=>this.onCancelSelect()}
        primaryAction={{
          content: intl.get("Submit"),
          onAction: () => this.onSubmitSelect(),
        }}
        secondaryActions={[
          {
            content: intl.get("Skip"),
            onAction: () => this.onCancelSelect(),
          },
        ]}
      >
        <Box className="select_cate_content">
        {warningMessage !== '' && <Banner title="Error reminder" tone="critical" onDismiss={()=>{
          this.setState({
            warningMessage:''
          })
        }}>
          {warningMessage}
        </Banner>}
          <Box>
           {intl.get("Please select the product category you are looking for, and we will recommend products in the corresponding category for you.")}
            recommend products in the corresponding category for you.
          </Box>
          <Box className="select_cate_box">
            {this.state.cateSelectData.map((item, ind) => (
              <Box className="select_cate_box_item" key={ind}>
                <Checkbox
                  label={item.label}
                  checked={item.select}
                  onChange={() => this.handleChangeSelect(item.value)}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Modal>
    );
    // 黑色星期五活动图片
    // const blackFridayBanner = !this.state.loadingPage && (
    //   <div
    //      className='black_friday_banner'
    //      onClick={()=>this.props.history.push('/admin/black-friday')}
    //      style={{
    //         backgroundImage: 'url(/blackFriday/banner_img.png)',
    //         marginTop: '3rem'
    //      }}>
    //   </div>
    // )

    let CheckGooglePluginMessage;
    if (GooglePluginInstall) {
      CheckGooglePluginMessage = (
        <ol className="check_google_plugin_ol">
          <li>
            {intl.get("Go to 1688")}{" "}
            <Link onClick={() => this.jumpUrl("https://www.1688.com")} external>
              https://www.1688.com
            </Link>
          </li>
          <li>
            {intl.get(
              "Select the products you want to import to your Shopify store, enter the product details page."
            )}
          </li>
          <li>
            {intl.get(
              'Enable Dropshipman Chrome Extension, then click the "Add to my store" button at the bottom right corner of the product details page to add the product.'
            )}
          </li>
          <li>
            {intl.get(
              "After the products are successfully added, you can find the corresponding products in the Product List > Dropshipman > Not imported in the Dropshipman APP."
            )}
          </li>
        </ol>
      );
    } else {
      CheckGooglePluginMessage = (
        <p style={{ fontSize: 16 }}>
          {intl.get(
            "We found that you haven't installed Dropshipman Chrome Extension, which will not facilitate you to sourcing goods from 1688. Do you want to install it?"
          )}
        </p>
      );
    }

    const CheckGooglePluginModal = (
      <Modal
        open={CheckGooglePluginActive}
        onClose={() => this.handleCheckGooglePluginModal()}
        title={
          GooglePluginInstall
            ? intl.get("Sourcing From 1688")
            : intl.get("Install Dropshipman Chrome Extension")
        }
        primaryAction={
          GooglePluginInstall
            ? {
                content: intl.get("Continue"),
                onAction: () => {
                  this.jumpUrl("https://www.1688.com");
                },
              }
            : {
                content: intl.get("Install"),
                onAction: () => {
                  this.jumpUrl(
                    "https://chrome.google.com/webstore/detail/dropshipman-aliexpresscom/bobhjedlciclpchpelkgiojkmmfgnihg?"
                  );
                },
              }
        }
        secondaryActions={
          !GooglePluginInstall && [
            {
              content: intl.get("Cancel"),
              onAction: () => this.handleCheckGooglePluginModal(),
            },
          ]
        }
      >
        <Modal.Section>{CheckGooglePluginMessage}</Modal.Section>
      </Modal>
    );

    return (
      <div>
        {/* 黑色星期五活动 */}
        {/* {blackFridayBanner} */}
        {/* { showUserPreferences && <UserProductPreferences show={showUserPreferences} callback={this.callBackCloseModal} />} */}
        {this.state.Imageload && (
          <div className={"loading_mask"}>
            <div className="full_height">
              <div className="spinner_find">
                <Spinner accessibilityLabel="Spinner example" size="large" />
              </div>
            </div>
          </div>
        )}
        {/* {this.state.Imageload && <div className='spinner_find'><Spinner accessibilityLabel="Spinner example" size="large" /></div> } */}

        {/* 页面内容 */}
        {pageContent}

        {toastMarkup}

        {!this.state.productAddSuccess && SingleOperationTipsModal}

        <div id="showTopButton">{RoundButton}</div>

        {CouponPopModal}
        {/* 未订阅 */}
        <Suspense fallback={<div>Loading...</div>}>
          <UpgradePlanModal
            upgradeOpen={this.state.upgradeModal}
            setUpgradeOpen={() => this.setState({ upgradeModal: false })}
          />
        </Suspense>
        {/* dsm产品导入限制 */}
        <Suspense fallback={<div>Loading...</div>}>
          <ImportDsmModal
            importOpen={this.state.importantDsmModal}
            num={this.state.importantDay}
            setImportOpen={() => this.setState({ importantDsmModal: false })}
          />
        </Suspense>
        {/* 偏好选择弹窗 */}
        {CateSelectPopModal}
        {/* 谷歌插件检测弹窗 */}
        {CheckGooglePluginModal}
      </div>
    );
  }
}
// const mapStateToProps = state => {
//   return {
//     subScriptData: state.languageReducer.subScriptData
//   }
// }
export default withRouter(FindProducts);
